// extracted by mini-css-extract-plugin
export default {"container":"CJ-z","disabled":"DJ-z","termsCheckbox":"EJ-z","signUpButton":"FJ-z","enrollingSpinner":"GJ-z","learnMoreButton":"HJ-z","buttonRow":"IJ-z"};